import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  Badge,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  ListItemButton,
  ListSubheader
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { Formik, Form } from "formik";
import { Link, useLocation } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { MdAttachFile, MdError, MdCancel, MdNotificationsNone } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { BsChatRightFill } from "react-icons/bs";
import * as UTILS from "../../../helpers/Utility";
import * as API from "../api";
import * as Validate from "../Validations";
import { useStyles } from "../layout/Styles";
import * as CONST from "../Constants";
import CallVipLink from "../layout/CallVipLink";
import Flash from "../layout/Flash";

const propTypes = {
  cpr: PropTypes.object,
  cprId: PropTypes.number,
  messages: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  window: () => Window,
  children: React.createElement,
  showMessages: PropTypes.boolean
};
Messages.prototype = propTypes;
export default function Messages(props) {
  const styles = useStyles();
  const location = useLocation();
  const [acknowledgement, showAcknowledgement] = useState(false);
  const [messages, setMessages] = useState(props.messages == null ? null : props.messages);
  const [flashMessage, setFlashMessage] = useState(null);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(props.messages && props.messages.length < 5);
  const [showMessages, setShowMessages] = useState(
    (window.location.href.match("messages") && window.location.href.match("messages").length > 0) || (props.showMessages == true) || (messages.length > 0));

  React.useEffect(() => {
    if (flashMessage) {
      setTimeout(() => {
        setFlashMessage(null);
      }, 5000);
    }
  }, [props.messages == null ? null : props.messages]);

  const FormInputWrapper = ({ form }) => {
    return (
      <Formik
        initialValues={{ value: "" }}
        validationSchema={form.validation}
        validateOnChange={true}
        onSubmit={async (values) => {
          let req = values.attachment ? new FormData() : {}
          if (values.attachment) {
            if (props.cprId) {
              req.append("task_message[cpr_id]", props.cprId);
            }
            req.append("task_message[body]", values.value);
            req.append("task_message[attachment]", values.attachment);
          } else {
            req = !props.cprId
              ? { task_message: { body: values.value } }
              : { task_message: { cpr_id: props.cprId, body: values.value } }
          }

          const res = await API.postTaskMessage(req);

          if (res.error) {
            setFlashMessage({ ...res });
          } else {
            showAcknowledgement(true);
            let responseData = res.data == undefined ? res.task_messages : res.data.task_messages
            setMessages(responseData);
            props.cprId
              ? props.dispatch({
                  type: "set_cpr_task_messages",
                  payload: responseData,
                })
              : props.dispatch({
                  type: "set_support_messages",
                  payload: responseData,
                });
            window.location.reload();
          }
        }}
      >
        {({ values, setFieldValue, errors, touched, isSubmitting, handleChange }) => {
          const onDrop = useCallback((acceptedFiles) => {
            setFieldValue("attachment", acceptedFiles[0]);
          }, []);
          const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
          return (
            <Box bgcolor="#fcfcfc4d" p={3} pb={4} id="scroll-to">
              {errors.value && touched && (
                <div className="error">
                  <MdError /> {errors.value}
                </div>
              )}

              <Form>
                <textarea
                  name={"value"}
                  value={values.value}
                  onChange={handleChange}
                  placeholder={props.cprId && form.placeholder}
                />
                {
                  !values.attachment && <div className="dropzone patient-portal-attachment" {...getRootProps()}>
                    <MdAttachFile className="attachment-icon" />
                    <input {...getInputProps()} />
                  </div>
                }
                {
                  values.attachment && <div className="attached-file" key={values.attachment.name}>
                    <MdCancel
                      className="cancel-attached"
                      onClick={() => setFieldValue("attachment", "")}
                    />
                    <MdAttachFile className="attachment-icon-small" />
                    {values.attachment.name}
                  </div>
                }
                <button
                  className="prompt confirm"
                  type="submit"
                  disabled={
                    errors.value || isSubmitting
                      ? true
                      : false
                  }
                >
                  {form.buttonText}
                </button>
              </Form>
            </Box>
          );
        }}
      </Formik>
    );
  };

  return (
    <>
      {flashMessage ? (
        <Flash flash={flashMessage} handleClose={() => setFlashMessage(null)} />
      ) : null}
      <Box pb={2} pt={1} pl={3} className="bb bt show-messages-header-btn" onClick={
        () => {
          setShowMessages(!showMessages);
        }
      }>
        <Typography variant="h5" color="#02a8f4" fontWeight="600">
          <BsChatRightFill className={styles.chatIcon} /> {CONST.MESSAGES}
          <ListItemIcon className={styles.floatRight}>
            <Badge badgeContent={messages.length} color="error">
            </Badge>
          </ListItemIcon>
          <i className='fa fa-hand-pointer-o'></i>
        </Typography>
      </Box>

      {!!messages.length > 0 && (showMessages == true) && (
        <Grid
          container
          columnSpacing={1}
          className="bb"
          sx={{ px: { xs: 1, sm: 1, md: 3 }, py: 2, bgcolor: "#ecf4f8" }}
        >
          {messages.map((message, idx) => (
            <React.Fragment key={idx}>
              {message.source !== "patient" ? (
                <Grid xs={8} xsOffset={"0"}>
                  <Box width="100%" mb={1} mt={1}>
                    <Box style={{wordWrap: "break-word", width: '100%'}} className="message-item" textAlign="left" bgcolor="#bcc8ce2b">
                      <Typography variant="messagebody">
                        <div dangerouslySetInnerHTML={{__html: message.body}} ></div>
                      </Typography>
                    </Box>
                    {message.attachment && message.attachment.url && (
                      <>
                        <a href={ message.attachment.url } className="document btn btn-default auto-width" rel="noopener noreferrer">
                          <MdAttachFile className="attachment-icon-small" />
                          {UTILS.FileNameFromUrl(message.attachment.url)}
                        </a>
                      </>
                    )}
                  </Box>

                  <Box color="#93a6b0" fontSize="18px">
                    {(message.support_agent_name
                      ? message.support_agent_name
                      : message.support_agent) + "  "}
                    {new Date(message.created_at).toLocaleTimeString([], {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                    })}
                  </Box>
                </Grid>
              ) : (
                <>
                  <Grid xs={8} xsOffset={4} alignItems="flex-end">
                    <Box sx={{ float: "right" }} width="100%" mb={1} mt={1}>
                      <Box sx={{ float: "right" }} className="message-item" bgcolor="#a9e4ff">
                        <Typography variant="messagebody">
                          <div dangerouslySetInnerHTML={{__html: message.body}} ></div>
                        </Typography>
                      </Box>
                      {message.attachment && message.attachment.url && (
                        <>
                          <a href={ message.attachment.url } className="document btn btn-default auto-width" rel="noopener noreferrer">
                            <MdAttachFile className="attachment-icon-small" />
                            {UTILS.FileNameFromUrl(message.attachment.url)}
                          </a>
                        </>
                      )}
                    </Box>

                    <Box color="#93a6b0" fontSize="18px" mt={-1} textAlign={"right"}>
                      {new Date(message.created_at).toLocaleTimeString([], {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                      })}
                    </Box>
                  </Grid>
                </>
              )}
            </React.Fragment>
          ))}

          {lastPage != true && (<div
            onClick={async (el) => {
              let res = await API.getTaskMessages(props.cprId, page + 1);

              if (res && res.data && res.data.task_messages) {
                setLastPage(res.data.last_page);
                console.log(res.data.last_page);
                if (res.data.task_messages.length > 0) {
                  setPage(page + 1);
                  let newMessages = messages.concat(res.data.task_messages);
                  setMessages(newMessages);
                }
              }
            }}
            className='btn btn-default'
          >
            Show more Messages (5)
          </div>)}

          {acknowledgement && props.cprId && props.cpr.status !== "closed" && (
            <Grid xs={12} alignItems="flex-end" textAlign={"end"} pt={1}>
              <Typography variant="messagebody" fontWeight={300} className="icon-text">
                <IoMdCheckmarkCircleOutline />
                {CONST.MESSAGE_SENT_SUCCESS}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}

      { showMessages == true &&
        <FormInputWrapper
          form={{
            ...CONST.TASK_MESSAGE_FIELD,
            validation: Validate.InputSchema,
            initialValue: "",
          }}
        />
      }
    </>
  );
}
